import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function GradeComments({ finalGradesList, selectedStudent, selectedTerm, gradeLetters }) {
    const { t } = useTranslation();

    const displayGrade = useMemo(() => {
        if (!Array.isArray(finalGradesList) || !selectedStudent || !selectedTerm) {
            return '-';
        }

        const studentRecord = finalGradesList.find(r => r.id === selectedStudent.id);

        if (!studentRecord || !Array.isArray(studentRecord.markingPeriodGrades)) {
            return '-';
        }

        const mpGradeRecord = studentRecord.markingPeriodGrades.find(
            mp => String(mp.markingPeriodId) === String(selectedTerm.id)
        );

        if (!mpGradeRecord || mpGradeRecord.grade === null || mpGradeRecord.grade === undefined) {
            return '-'; 
        }

        const gradeValue = mpGradeRecord.grade;

        if (gradeLetters && Array.isArray(gradeLetters)) {
            let match = gradeLetters.find(gl => String(gl.maxGrade) === String(gradeValue));
            
            if (!match) {
                match = gradeLetters.find(gl => String(gl.id) === String(gradeValue));
            }

            if (match) {
                if (match.description) {
                    return `${match.letterGrade} - ${match.description}`;
                }
                return match.letterGrade;
            }
        }
        
        return gradeValue;

    }, [finalGradesList, selectedStudent, selectedTerm, gradeLetters]);

    const commentText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.";

    return (
        <Box sx={{ mt: 3 }}>
            <Box>
                <Typography variant="subtitle1" component="h3" sx={{ mt: 1 }}>
                    {t('Grade')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {displayGrade}
                </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1" component="h3" sx={{ mt: 1 }}>
                    {t('Comment')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {commentText}
                </Typography>
            </Box>

        </Box>
    )
}